import { useGetPaymentTypesQuery } from "../../../hooks/useGetPaymentTypesQuery";
import { CoursePaymentType } from "../../../types/Finance";
import { useForm } from "react-hook-form";
import { useGetFacultiesQuery } from "../../../hooks/useGetFacultiesQuery";
import { useGetDepartamentsQuery } from "../../../hooks/useGetDepartamentsQuery";
import { useNavigate } from "react-router-dom";
import { useMutation } from "react-query";
import {
  createCoursePayment,
  updateCoursePayment,
} from "../../../services/finance/coursePayments";
import { routes } from "../../../routes";
import toast from "react-hot-toast";
import { Button, Card, Flex, Spinner } from "@radix-ui/themes";
import SelectComponent from "../../../components/inputs/Select/SelectComponent";
import { ChevronLeftIcon, EnterIcon } from "@radix-ui/react-icons";
import { useGetCoursesQuery } from "../../../hooks/useGetCoursesQuery";
import RadioGroupComponent from "../../../components/inputs/RadioGroup/RadioGroupComponent";
import TextFieldComponent from "../../../components/inputs/Textfield/TextfieldComponent";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { isEmpty } from "lodash";
import { useGetUniversitiesQuery } from "../../../hooks/useGetUniversitiesQuery";
import CheckboxComponent from "../../../components/inputs/Checkbox/CheckboxComponent";
export const UpdateCoursePayment = () => {
  const navigate = useNavigate();
  const mutation = useMutation({
    mutationFn: updateCoursePayment,
    mutationKey: "updateCoursePayment",
  });
  const coursePaymentData = useSelector(
    (state: RootState) => state.coursePayment
  );

  const {
    data: paymentTypesData,
    status: paymentTypesStatus,
    isError: isErrorPaymentTypes,
    isLoading: isLoadingPaymentTypes,
  } = useGetPaymentTypesQuery({ PageNumber: 1, PageSize: 400 });
  const defaultValues: CoursePaymentType = {
    ...coursePaymentData,
  };
  const {
    control,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors },
  } = useForm<CoursePaymentType>({
    defaultValues,
    mode: "onBlur",
    reValidateMode: "onBlur",
    shouldUseNativeValidation: false,
  });
  const {
    data: universities,
    isLoading: isLoadingUniversities,
    isError: errorUniversities,
    refetch: refetchUniversities,
  } = useGetUniversitiesQuery({ PageNumber: 1, PageSize: 400 });
  const {
    data: faculties,
    isLoading: isLoadingFaculties,
    isError: errorFaculties,
    refetch: refetchFaculties,
  } = useGetFacultiesQuery({
    PageNumber: 1,
    PageSize: 400,
    IdUniversity: getValues("idUniversity"),
  });
  const {
    data: departaments,
    isLoading: isLoadingDepartaments,
    isError: errorDepartaments,
    refetch: refreshDepartaments,
  } = useGetDepartamentsQuery(
    { PageNumber: 1, PageSize: 400, IdFaculty: getValues("idFaculty") },
    { enabled: !!getValues("idFaculty") }
  );
  const {
    data: courses,
    isLoading: isLoadingCourses,
    isError: errorCourses,
    refetch: refreshCourses,
  } = useGetCoursesQuery(
    { PageNumber: 1, PageSize: 400, IdDepartament: getValues("idDepartament") },
    { enabled: !!getValues("idDepartament") }
  );
  const handleFacultyChange = (idFaculty: string) => {
    setValue("idFaculty", idFaculty);
    setValue("idDepartament", "");
    setValue("idCourse", "");
    refreshDepartaments();
  };
  const handleDepartamentChange = (idDepartament: string) => {
    setValue("idDepartament", idDepartament);
    setValue("idCourse", "");
    refreshCourses();
  };
  const handleBack = () => {
    navigate(routes.coursePayments);
  };
  const onSubmit = handleSubmit(async (data) => {
    try {
      try {
        data.course = courses?.items.find((i) => i.id === data.idCourse)?.name;
        if (isEmpty(data.description)) {
          data.description = `${
            courses?.items.find((i) => i.id === data.idCourse)?.name
          } - ${
            paymentTypesData?.items.find((i) => i.id === data.idPaymentType)
              ?.description
          }`;
        }
      } catch (ex) {}
      const result = await mutation.mutateAsync(data);
      if (result) {
        toast.success("Modelo criado");
        navigate(routes.coursePayments);
      }
    } catch (err: any) {
      toast.error(`${mutation.error ?? err?.message}`);
    }
  });
  const handleUniversityChange = (id: string) => {
    setValue("idUniversity", id);
    setValue("idFaculty", "");
    setValue("idDepartament", "");
    refetchFaculties();
  };

  return (
    <form onSubmit={onSubmit} noValidate>
      <Card size="1">
        <Flex direction="column" gap="4">
          <Flex gap="8">
            <TextFieldComponent
              name="description"
              label="Descrição"
              control={control}
              errors={errors}
              fieldProps={{ placeholder: "Descrição" }}
              style={{ width: "100%" }}
            />
          </Flex>
          <SelectComponent
            name="idUniversity"
            label="Instituição de Ensino Superior"
            control={control}
            errors={errors}
            style={{ width: "100%" }}
            options={universities?.items.map((u) => ({
              value: u.id ?? "",
              label: u.description ?? "",
            }))}
            itemsLoading={isLoadingUniversities}
            itemsError={errorUniversities}
            onSelect={handleUniversityChange}
            required={true}
          />

          <SelectComponent
            name="idFaculty"
            label="Unidade orgânica"
            control={control}
            errors={errors}
            style={{ width: "100%" }}
            options={faculties?.items.map((faculty) => ({
              value: faculty.id ?? "",
              label: faculty.description ?? "",
            }))}
            onSelect={handleFacultyChange}
          />
          <SelectComponent
            name="idDepartament"
            label="Departamento"
            control={control}
            errors={errors}
            style={{ width: "100%" }}
            options={departaments?.items.map((departament) => ({
              value: departament.id ?? "",
              label: departament.description ?? "",
            }))}
            onSelect={handleDepartamentChange}
          />
          <SelectComponent
            itemsError={errorCourses}
            itemsLoading={isLoadingCourses}
            name="idCourse"
            label="Curso"
            control={control}
            errors={errors}
            style={{ width: "100%" }}
            options={courses?.items.map((d) => ({
              value: d.id ?? "",
              label: d.description ?? "",
            }))}
          />

          <Flex gap="8">
            <RadioGroupComponent
              name="regime"
              label="Regime"
              control={control}
              errors={errors}
              style={{ width: "100%" }}
              options={[
                { value: "1", label: "Laboral" },
                { value: "2", label: "Pós Laboral" },
                { value: "3", label: "Distância" },
              ]}
              fieldProps={{
                style: { display: "flex", flexDirection: "row", gap: "16px" },
              }}
            />
          </Flex>
          <SelectComponent
            name="idPaymentType"
            label="Tipo de emolumento"
            control={control}
            errors={errors}
            itemsLoading={isLoadingPaymentTypes}
            itemsError={isErrorPaymentTypes}
            options={
              paymentTypesData?.items?.map((item) => ({
                value: item.id!,
                label: String(item.description!) ?? "",
              })) ?? []
            }
            style={{ width: "100%" }}
          />
          <CheckboxComponent
            name="isToDebtsGenerateAutomatically"
            label="Gerar automaticamente as cobranças/refs."
            control={control}
            errors={errors}
            required
            onChange={(checked: any) => console.log(":", checked)}
          />
          <CheckboxComponent
            name="isOneSubjectSubscribed"
            label="Quando inscrito a uma cadeira?"
            control={control}
            errors={errors}
            required
            onChange={(checked: any) => console.log(":", checked)}
          />
          <SelectComponent
            name="idPaymentWhenOneSubjectSubscribed"
            label="Tipo de emolumento quando estiver inscrito a uma cadeira"
            control={control}
            errors={errors}
            itemsLoading={isLoadingPaymentTypes}
            itemsError={isErrorPaymentTypes}
            options={
              paymentTypesData?.items?.map((item) => ({
                value: item.id!,
                label: String(item.description!) ?? "",
              })) ?? []
            }
            style={{ width: "100%" }}
          />
          <SelectComponent
            name="idPaymentWhenOneSubjectSubscribedMonography"
            label="Tipo de emolumento quando estiver inscrito a monografia"
            control={control}
            errors={errors}
            itemsLoading={isLoadingPaymentTypes}
            itemsError={isErrorPaymentTypes}
            options={
              paymentTypesData?.items?.map((item) => ({
                value: item.id!,
                label: String(item.description!) ?? "",
              })) ?? []
            }
            style={{ width: "100%" }}
          />
          <SelectComponent
            name="IdPaymentWhenTwoSubjectSubscribedCurrentAndMonography"
            label="Tipo de emolumento quando estiver inscrito a duas cadeiras e monografia"
            control={control}
            errors={errors}
            itemsLoading={isLoadingPaymentTypes}
            itemsError={isErrorPaymentTypes}
            options={
              paymentTypesData?.items?.map((item) => ({
                value: item.id!,
                label: String(item.description!) ?? "",
              })) ?? []
            }
            style={{ width: "100%" }}
          />
          <Flex direction="row" gap="4" style={{ alignSelf: "end" }}>
            <Button
              color="red"
              onClick={handleBack}
              disabled={mutation.isLoading}
            >
              <ChevronLeftIcon /> voltar
            </Button>
            <Button
              type="submit"
              disabled={mutation.isLoading}
              variant="surface"
            >
              {mutation.isLoading ? (
                <Spinner loading>
                  {" "}
                  <EnterIcon />
                </Spinner>
              ) : (
                <EnterIcon />
              )}
              Registar
            </Button>
          </Flex>
        </Flex>
      </Card>
    </form>
  );
};
